module.exports = __webpack_public_path__ + "pc/img/rec_25.f7202941.svg";